import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import TableFixedPage from "../../../TableFixedPage/TableFixedPage";
import {
  EditUserAPI,
  getSupplierInfoApi,
} from "../../../../Api/PanelAdminServices";
import Style from "./EditSupplierContainer.module.scss";
import Resizer from "react-image-file-resizer";
import Select from "react-select";
import { errorToast, succToast } from "../../../../Utils/Toast/Toast";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";

const EditSupplierContainer = () => {
  const [photo, setPhoto] = useState("");
  const [chooseCity, setChooseCity] = useState();
  const [chooseTypeState, setChoosetTypeState] = useState();
  const [UserInfoState, setUserInfoState] = useState(null);
  const [disable, setDisable] = useState(false);
  const params=useParams()

  const city = [
    {
      value: "1",
      label: "بهشهر",
      cityId: "4851",
    },
    {
      value: "2",
      label: "گلوگاه",
      cityId: "4861",
    },
    {
      value: "3",
      label: "نکا",
      cityId: "4841",
    },
  ];
  const SupplierType = [
    {
      value: "1",
      label: "رستوران",
      type: "food",
    },
    {
      value: "2",
      label: "فروشگاه",
      type: "supermarket",
    }
  ];

  useEffect(() => {
    getDataHandler();
  }, []);
  const getDataHandler = () => {
    getSupplierInfoApi(params.id,(succ,res)=>{
      if(res.status===1){
        setUserInfoState(res.info)
      }else{
        errorToast(res.message)
      }
    })

  };


  //////آپلود کردن عکس
  const UploadPhoto = async (image) => {
    return await resizeFileLogo(image);
  };
  /////ریسایز کردن logo برای آپلود
  const resizeFileLogo = (file) =>
    new Promise((resolve) => {
      Resizer.imageFileResizer(
        file,
        1024,
        1024,
        "WEBP",
        100,
        0,
        (uri) => {
          setPhoto(uri);
        },
        "base64"
      );
    });
  //////validation input //////////
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onsubmit = (data) => {
    setDisable(true);
    let info = {
      id:params.id,
      first_name: data.first_name,
      last_name: data.last_name,
      phone: data.phone,
      phone_2: data.phone_2,
      phone_3: data.phone_3,
      email: data.email ? data.email : "",
      city_id:chooseCity===undefined?UserInfoState.city_id: chooseCity.cityId,
      type:chooseTypeState===undefined?UserInfoState.type: chooseTypeState.type,
      name: data.name,
      telephone: data.telephone,
      address: data.address,
      about_us: data.about_us,
      min_cart: data.min_cart,
      fee: data.fee,
      packed_product_fee: data.packed_product_fee,
      user_type: "supplier",
      lat:"",
      lon:"",
      logo:"",
      cover:"",

    };
    EditUserAPI(info, (res) => {
      if (res.status === 1) {
        succToast(res.message);
        setDisable(false);
      } else {
        errorToast(res.message);
        setDisable(false);
      }
      setDisable(false);
    });
  };
  return (
    <div className={Style.componentHolder}>
      <TableFixedPage title={"ویرایش تامین کننده "} />
      {
        UserInfoState&&      <form onSubmit={handleSubmit(onsubmit)} className={Style.formPart}>
        <div className={Style.inputHolder}>
          {/* <section className={Style.logoPart}>
            <div className={Style.titleLogo}>بارگذاری تصویر</div>
            <div className={Style.uploadImage}>
              <img src={photo} alt="" />
            </div>
            <input
              id={"uploadPhoto"}
              type="file"
              style={{ display: "none" }}
              onChange={(e) => UploadPhoto(e.target.files[0])}
            />
            <label htmlFor={"uploadPhoto"} className={Style.iconHolder}>
              <FontAwesomeIcon className={Style.icon} icon={faImage} />
            </label>
            <h3 className={Style.textLogo}>بارگذاری تصویر</h3>
          </section> */}

          <input
            className={errors.first_name ? Style.errorInput : Style.inputPart}
            defaultValue={UserInfoState.first_name}
            placeholder={"نام"}
            {...register("first_name", { required: true })}
          />

          <input
            className={errors.last_name ? Style.errorInput : Style.inputPart}
            defaultValue={UserInfoState.last_name}
            placeholder={"نام خانوادگی "}
            {...register("last_name", { required: true })}
          />

          <Select
            onChange={setChooseCity}
            options={city}
            placeholder={" شهر"}
            className={Style.selectPart}
            defaultValue = {
              city.filter(option => 
                 option.cityId === UserInfoState.city_id)
           }
          />
                    <Select
            onChange={setChoosetTypeState}
            options={SupplierType}
            placeholder={" نوع تامین کننده"}
            className={Style.selectPart}
            defaultValue = {
              SupplierType.filter(option => 
                 option.type === UserInfoState.type)
           }
          />

          <input
            className={errors.phone ? Style.errorInput : Style.inputPart}
            defaultValue={UserInfoState.phone}
            placeholder={"شماره همراه"}
            {...register("phone", { required: true })}
          />
          <input
            className={errors.phone_2 ? Style.errorInput : Style.inputPart}
            defaultValue={UserInfoState.phone_2}
            placeholder={"شماره همراه2"}
            {...register("phone_2", { required: true })}
          />
          <input
            className={errors.phone_3 ? Style.errorInput : Style.inputPart}
            defaultValue={UserInfoState.phone_3}
            placeholder={"شماره همراه3"}
            {...register("phone_3", { required: true })}
          />
          <input
            className={Style.inputPart}
            defaultValue={UserInfoState.email}
            placeholder={"ایمیل "}
            {...register("email")}
          />
          <input
            className={errors.name ? Style.errorInput : Style.inputPart}
            defaultValue={UserInfoState.name}
            placeholder={"نام فروشگاه "}
            {...register("name", { required: true })}
          />
          <input
            className={
              errors.telephone ? Style.errorInput : Style.inputPart
            }
            defaultValue={UserInfoState.telephone}
            placeholder={"تلفن فروشگاه "}
            {...register("telephone", { required: true })}
          />
          <input
            className={
              errors.address ? Style.errorInput : Style.inputPart
            }
            defaultValue={UserInfoState.address}
            placeholder={"آدرس فروشگاه "}
            {...register("address", { required: true })}
          />
          <input
            className={
              errors.about_us ? Style.errorInput : Style.inputPart
            }
            defaultValue={UserInfoState.about_us}
            placeholder={"درباره فروشگاه "}
            {...register("about_us", { required: true })}
          />
          <input
            className={
              errors.min_cart ? Style.errorInput : Style.inputPart
            }
            defaultValue={UserInfoState.min_cart}
            placeholder={"حداقل مبلغ خرید"}
            {...register("min_cart", { required: true })}
          />
          <input
            className={
              errors.fee ? Style.errorInput : Style.inputPart
            }
            defaultValue={UserInfoState.fee}
            placeholder={"کارمزد"}
            {...register("fee", { required: true })}
          />
          <input
            className={
              errors.packed_product_fee ? Style.errorInput : Style.inputPart
            }
            defaultValue={UserInfoState.packed_product_fee}
            placeholder={"کارمزد بسته بندی"}
            {...register("packed_product_fee", { required: true })}
          />


          <button className={Style.btnStyle} type={"submit"} disabled={disable}>
            {
              disable? 'در حال ارسال اطلاعات':'ذخیره کردن'
            }
          </button>
        </div>
      </form>
      }
    </div>
  );
};

export default EditSupplierContainer;
